import { attributes, define } from "@type-r/models";
import { Loading } from "lqx-react";
import * as React from "react";
import { useIO, useLinked } from "@type-r/react";
import { globalStore } from "api";
import { PendingActionsInvoices, TimeRangeTypes } from "../../api";
import { LandingItems } from "../../common/landing-items";

const TIME_RANGE_DEFAULT = TimeRangeTypes.slice(1)[0].val;

@define
export class ReviewSentOutInvoicesState extends attributes({
    invoices: [PendingActionsInvoices],
    isReady: Boolean
}) {
    async fetch(options?) {

        const sentOutInvoices = await PendingActionsInvoices.fetchSentOutInvoices(options ? options.$timeRange.value : TIME_RANGE_DEFAULT);

        this.invoices.set(sentOutInvoices);

        this.invoices.updateEach(element => {
            let customer = globalStore.getRelationshipById(element.relationshipId).Customer;
            element.customerName = customer.companyName;
            element.customerExternalId = customer.externalRelationshipId;
        });

        return this;
    }

    getCount() {
        return this.invoices.reduce((sum: number, curr) => sum + (curr ? curr.count : 0), 0);
    }
}

export const SentOutInvoices = ({ state }: { state: ReviewSentOutInvoicesState }) => {

    const $timeRange = useLinked(TIME_RANGE_DEFAULT);

    state.isReady = useIO(async () =>

        await state.fetch({ $timeRange }

    ), [$timeRange.value]);
   
    return (
        state.isReady  ?
            <LandingItems
                title={`Review items (${state.getCount()})`}
                items={state.invoices}
                linkUrl='/invoices/statement'
                type='sent-out-invoices'
                $timeRange={$timeRange}
            />
            :
            <Loading />
    );
}